import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ButtonZegel from "../../components/Buttons/ButtonZegel";
import {
  ObtenerProgresoCursoPorPersonaCurso,
  ObtenerProgresoCursoPorPersonaPrograma,
  ObtenerEvaluacionesPersonaPrograma,
} from "../../services/CursoService";
import { ListarUnidadesPorCurso } from "../../services/UnidadService";
import "./styles/ProgresoCurso.scss";
import { ProgressSpinner } from "primereact/progressspinner";

import { ListarBibliotecasPorCurso } from "../../services/BibliotecaServices";
import { ListarLeccionesPorUnidad } from "../../services/LeccionServices";

import FooterInterno from "../../components/Footer/FooterInterno";
import useAlumno from "../../hooks/useAlumno";
import { BuscarProgramaID } from "../../services/ProgramaService";
import {
  ActualizarCursoEstado,
  ObtenerCursosPorUsuarioCurso,
  ObtenerPersonaPorId,
  ObtenerCursosPorPersonaPrograma,
  ObtenerCursosPorUsuario,
  ObtenerUnidadesPorPersonaPrograma,
  ObtenerLeccionesPorPersonaPrograma,
  ObtenerPersonaProgramaPorIdPersonaPrograma,
} from "../../services/UsuarioService";
import CardDownloadPrograma from "../components/CardDownloadPrograma/CardDownloadPrograma";

import { ObtenerEvaluacionesPersonaCurso } from "../../services/EvaluacionService";

import DialogZegel from "../../components/Dialog/DialogZegel";
import AvanceModulosComponent from "../components/AvanceModulos/AvanceModulosComponent";
import BibliotecaVirtualComponent from "../components/BibliotecaVirtual/BibliotecaVirtualComponent";
import CardBienvenidaProgramaComponent from "../components/CardBienvenidaPrograma/CardBienvenidaProgramaComponent";
import CardCursoVideoInicioComponent from "../components/CardCursoVideoInicio/CardCursoVideoInicioComponent";
import MiProgresoTituloComponent from "../components/MiProgresoTitulo/MiProgresoTituloComponent";
import ModulosAcordionProgramaComponent from "../components/ModulosAcordionPrograma/ModulosAcordionProgramaComponent";
import PreguntasFrecuentesComponent from "../components/PreguntasFrecuentes/PreguntasFrecuentesComponent";
import LoadingGlobal from "../components/LoadingGlobal/LoadingGlobal";

const ProgresoPrograma = () => {
  const navigate = useNavigate();
  let { perfil } = useAlumno();
  let { idPrograma } = useParams();
  let { idPersonaPrograma } = useParams();
  
  // States
  const [curso, setCurso] = useState({ nombre: "" });
  const [listaBiblioteca, setListaBiblioteca] = useState([]);
  const [cursoPersona, setcursoPersona] = useState([{ idEstado: 2 }]);
  const [Persona, setPersona] = useState([]);
  const [programa, setPrograma] = useState([]);
  const [listaCursoPrograma, setlistaCursoPrograma] = useState(null);
  const [loadingGlobal, setLoadingGlobal] = useState(false);
  const [listaUnidadeCursoPrograma, setlistaUnidadeCursoPrograma] = useState(null);
  const [listaLeccionUnidadeCursoPrograma, setlistaLeccionUnidadeCursoPrograma] = useState(null);
  const [listaProgresoLeccionUnidadeCursoPrograma, setlistaProgresoLeccionUnidadeCursoPrograma] = useState(null);
  const [listaEvaluacionesUnidadeCursoPrograma, setlistaEvaluacionesUnidadeCursoPrograma] = useState(null);
  const [showAlert, setShowAlert] = useState(null);
  const [contenidoAlertActivar, setContenidoAlertActivar] = useState(null);
  const [cursoActivarSeleccion, setcursoActivarSeleccion] = useState(null);
  const [listaCursosProgramasPersona, setListaCursosProgramasPersona] = useState(null);
  const [cursosActivos, setCursosActivos] = useState(null);
  const [loading, setLoading] = useState(false);
  const [spinnerCertificado, setspinnerCertificado] = useState(false);
  const [spinnerNotas, setspinnerNotas] = useState(false);
  const [PersonaProgamaData, setPersonaProgamaData] = useState(null);
  const [LeccionesPendientes, setLeccionesPendientes] = useState(null);

  // Refs para control de ejecución
  const fetchInProgress = useRef(false);

  // ✅ ÚNICO useEffect optimizado
  useEffect(() => {
    // Reset del flag cuando cambia el idPersonaPrograma (navegación)
    fetchInProgress.current = false;

    // Prevenir ejecución si faltan datos
    if (!idPersonaPrograma || !perfil?.idUsuario) return;

    // Prevenir ejecución duplicada
    if (fetchInProgress.current) return;

    fetchInProgress.current = true;
    let isActive = true;
    setLoadingGlobal(true);

    const fetchAllData = async () => {
      try {
        const jwt = window.localStorage.getItem("jwt");

        // 1. Obtener unidades
        const unidades = await ObtenerUnidadesPorPersonaPrograma({
          jwt,
          id: idPersonaPrograma,
        });
        if (!isActive) return;

        // 2. Obtener lecciones
        const lecciones = await ObtenerLeccionesPorPersonaPrograma({
          jwt,
          id: idPersonaPrograma,
        });
        if (!isActive) return;

        // 3. Obtener progreso
        const progreso = await ObtenerProgresoCursoPorPersonaPrograma({
          jwt,
          id: idPersonaPrograma,
        });
        if (!isActive) return;

        // 4. Obtener evaluaciones
        const evaluaciones = await ObtenerEvaluacionesPersonaPrograma({
          jwt,
          id: idPersonaPrograma,
        });
        if (!isActive) return;

        // 5. Obtener persona programa
        const personaPrograma = await ObtenerPersonaProgramaPorIdPersonaPrograma({
          jwt,
          id: idPersonaPrograma,
        });
        if (!isActive) return;
        setPersonaProgamaData(personaPrograma);

        // 6. Cargar datos del programa
        await cargarDatosPrograma(evaluaciones, unidades, lecciones, progreso, isActive);

        if (isActive) {
          setLoadingGlobal(false);
        }
      } catch (error) {
        console.error("Error cargando datos:", error);
        if (isActive) {
          setLoadingGlobal(false);
        }
      } finally {
        fetchInProgress.current = false;
      }
    };

    fetchAllData();

    // Cleanup function
    return () => {
      isActive = false;
    };
  }, [idPersonaPrograma, perfil?.idUsuario]);

  // Función que procesa todos los datos del programa
  const cargarDatosPrograma = async (evaluaciones, unidades, lecciones, progreso, isActive) => {
    const jwt = window.localStorage.getItem("jwt");
    
    // Verificar que perfil exista
    if (!perfil?.idUsuario) {
      console.error("Perfil no disponible");
      return;
    }
    
    const idUsuario = perfil.idUsuario.toString();

    // Obtener persona
    const dataP = await ObtenerPersonaPorId({ jwt, idPersona: idUsuario });
    if (!isActive) return;
    setPersona(dataP);

    // Obtener programa
    const dataPrograma = await BuscarProgramaID({ jwt, idPrograma });
    if (!isActive) return;
    setPrograma(dataPrograma);

    // Variables auxiliares
    const auxsetcursoPersona = [];
    const auxlistaUnidadeCursoPrograma = [];
    const auxlistaLeccionUnidadeCursoPrograma = [];
    const auxlistaProgresoLeccionUnidadeCursoPrograma = [];
    const auxsetListaBiblioteca = [];
    const auxlistaEvaluacionesUnidadeCursoPrograma = [];
    const vLeccionesPendientesUnidades = [];

    // Obtener cursos
    const dataCursos = await ObtenerCursosPorPersonaPrograma({
      jwt,
      id: idPersonaPrograma,
    });
    if (!isActive) return;

    for (let i = 0; i < dataCursos.length; i++) {
      const idCurso = dataCursos[i].idCurso;
      auxsetcursoPersona.push(dataCursos[i]);

      if (dataCursos.length > 0) {
        const idPersonaCurso = dataCursos[i].idPersonaCurso;

        // Filtrar progreso
        let ListProgresoCursoPorPersonaProgramaFilter =
          progreso?.filter((z) => z.idPersonaCurso === idPersonaCurso) || [];

        // Filtrar evaluaciones
        const ListEvaluacionesPersonaProgramaFilter = evaluaciones.filter(
          (a) => a.idPersonaCurso === idPersonaCurso
        );

        for (let eva = 0; eva < ListEvaluacionesPersonaProgramaFilter.length; eva++) {
          auxlistaEvaluacionesUnidadeCursoPrograma.push(
            ListEvaluacionesPersonaProgramaFilter[eva]
          );
        }

        // Procesar unidades
        const dataUnidades = unidades.filter((x) => x.idCurso === idCurso);

        for (let k = 0; k < dataUnidades.length; k++) {
          auxlistaUnidadeCursoPrograma.push(dataUnidades[k]);
          const idUnidad = dataUnidades[k].idUnidad;

          const vLeccionesPendientesUnidad = {
            idCurso: idCurso,
            idUnidad: idUnidad,
            leccionesPendientes: [],
          };

          // Procesar lecciones
          const dataLecciones = lecciones.filter((y) => y.idUnidad === idUnidad);

          for (let j = 0; j < dataLecciones.length; j++) {
            auxlistaLeccionUnidadeCursoPrograma.push(dataLecciones[j]);

            const resultadosFiltrados = ListProgresoCursoPorPersonaProgramaFilter.filter(
              (item) => item.idLeccion === dataLecciones[j].idLeccion
            );

            if (resultadosFiltrados.length > 0) {
              const fechaActual = new Date(resultadosFiltrados[0].tiempoVideoActual);
              const fechaTotal = new Date(resultadosFiltrados[0].tiempoVideoTotal);

              const opcionesHora = {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              };
              const horaActual = fechaActual.toLocaleTimeString("es-ES", opcionesHora);
              const horaTotal = fechaTotal.toLocaleTimeString("es-ES", opcionesHora);

              const parteshoraActual = horaActual.split(":");
              const horashoraActual = parseInt(parteshoraActual[0], 10);
              const minutoshoraActual = parseInt(parteshoraActual[1], 10);
              const segundoshoraActual = 13 + parseInt(parteshoraActual[2], 10);

              const parteshoraTotal = horaTotal.split(":");
              const horashoraTotal = parseInt(parteshoraTotal[0], 10);
              const minutoshoraTotal = parseInt(parteshoraTotal[1], 10);
              const segundoshoraTotal = parseInt(parteshoraTotal[2], 10);

              const totalSegundoshoraActual =
                horashoraActual * 3600 + minutoshoraActual * 60 + segundoshoraActual;
              const totalSegundoshoraTotal =
                horashoraTotal * 3600 + minutoshoraTotal * 60 + segundoshoraTotal;

              let porcentaje = (totalSegundoshoraActual * 100) / totalSegundoshoraTotal;

              const ProgresoUnidad = {
                idCurso: idCurso,
                idUnidad: idUnidad,
                idProgresoCurso: resultadosFiltrados[0].idProgresoCurso,
                idPersonaCurso: resultadosFiltrados[0].idPersonaCurso,
                idLeccion: resultadosFiltrados[0].idLeccion,
                tiempoVideoActual: resultadosFiltrados[0].tiempoVideoActual,
                tiempoVideoTotal: resultadosFiltrados[0].tiempoVideoTotal,
                PorcentajeAvance: porcentaje > 100 ? 100 : porcentaje,
              };

              auxlistaProgresoLeccionUnidadeCursoPrograma.push(ProgresoUnidad);
            } else {
              vLeccionesPendientesUnidad.leccionesPendientes.push(j + 1);
            }
          }

          vLeccionesPendientesUnidades.push(vLeccionesPendientesUnidad);
        }
      }
    }

    // Actualizar states solo si el componente sigue activo
    if (!isActive) return;
    
    setLeccionesPendientes(vLeccionesPendientesUnidades);
    setlistaCursoPrograma(auxsetcursoPersona);
    setlistaUnidadeCursoPrograma(auxlistaUnidadeCursoPrograma);
    setlistaLeccionUnidadeCursoPrograma(auxlistaLeccionUnidadeCursoPrograma);
    setlistaProgresoLeccionUnidadeCursoPrograma(auxlistaProgresoLeccionUnidadeCursoPrograma);
    setlistaEvaluacionesUnidadeCursoPrograma(auxlistaEvaluacionesUnidadeCursoPrograma);

    // Cargar biblioteca
    if (auxsetcursoPersona.length > 0) {
      const idCurso = auxsetcursoPersona[0].idCurso;
      const dataBiblioteca = await ListarBibliotecasPorCurso({ jwt, idCurso });
      if (!isActive) return;

      for (let B = 0; B < dataBiblioteca.length; B++) {
        auxsetListaBiblioteca.push(dataBiblioteca[B]);
      }

      setListaBiblioteca(auxsetListaBiblioteca);
    }
  };

  function CursoEvaluacion(props) {
    if (listaEvaluacionesUnidadeCursoPrograma) {
      var unidades = listaUnidadeCursoPrograma.filter(
        (x) => x.idCurso === props.idCurso
      );
      var promediototal = 0;
      for (let k = 0; k < unidades.length; k++) {
        if (listaEvaluacionesUnidadeCursoPrograma.length > 0) {
          var evaluacionesUnidad = listaEvaluacionesUnidadeCursoPrograma.filter(
            (x) => x.idUnidad === unidades[k].idUnidad
          );
          if (evaluacionesUnidad.length > 0) {
            const notas = evaluacionesUnidad.map((evaluacion) => evaluacion.nota);
            const notaMasAlta = Math.max(...notas);
            promediototal = promediototal + notaMasAlta;
          }
        }
      }
      promediototal = promediototal / unidades.length;
      return (
        <span className="fontsizesmall ">
          Promedio del módulo{" "}
          {promediototal === 0 ? "--" : promediototal.toFixed()}
        </span>
      );
    } else {
      return <span className="fontsizesmall ">Promedio del módulo --</span>;
    }
  }

  const Actualizar = () => {
    setLoading(true);
    let idPersonaCurso = listaCursoPrograma[cursoActivarSeleccion].idPersonaCurso;
    let idCurso = listaCursoPrograma[cursoActivarSeleccion].idCurso;
    let finCurso = listaCursoPrograma[cursoActivarSeleccion].finCurso;
    let idUsuario = listaCursoPrograma[cursoActivarSeleccion].idUsuario;
    let idEstado = 2;
    let jsonCurso = JSON.stringify(
      { idPersonaCurso, idUsuario, idCurso, finCurso, idEstado },
      null,
      2
    );
    let jwt = window.localStorage.getItem("jwt");

    ActualizarCursoEstado({ jsonCurso, jwt }).then((data) => {
      setTimeout(() => {
        setShowAlert(false);
        window.location.reload();
      }, 3000);
      setLoading(false);
    });
  };

  const footerActivar = (
    <>
      <div style={{ marginBottom: 8 }}>
        <ButtonZegel
          label="Activar curso"
          color="primary"
          onClick={() => Actualizar()}
        ></ButtonZegel>
      </div>
      <div>
        <ButtonZegel
          label="Cancelar"
          color="secondary"
          onClick={() => setShowAlert(false)}
        ></ButtonZegel>
      </div>
    </>
  );

  return (
    <>
      <div className="dashboard-progreso">
        <LoadingGlobal loadingGlobal={loadingGlobal} />

        <div className="progreso-header">
          <div className="container-center-auto">
            <button
              className="p-link-button button-img"
              onClick={() => navigate("/Inicio/Dashboard")}
              style={{
                fontWeight: "bold",
                color: "#000",
              }}
            >
              <i className="pi pi-arrow-left" style={{ fontSize: "1rem" }}></i>
            </button>
          </div>
        </div>

        {/* Solo mostrar contenido si hay datos cargados */}
        {!loadingGlobal && listaCursoPrograma && programa && (
          <div className="progreso-contenido content-general-navigation">
            <MiProgresoTituloComponent />
            <div className="p-fluid formgrid grid">
              <CardBienvenidaProgramaComponent
                Persona={Persona}
                programa={programa}
                listaProgresoLeccionUnidadeCursoPrograma={
                  listaProgresoLeccionUnidadeCursoPrograma
                }
                listaLeccionUnidadeCursoPrograma={listaLeccionUnidadeCursoPrograma}
                listaEvaluacionesUnidadeCursoPrograma={
                  listaEvaluacionesUnidadeCursoPrograma
                }
                listaUnidadeCursoPrograma={listaUnidadeCursoPrograma}
                listaCursoPrograma={listaCursoPrograma}
                setspinnerCertificado={setspinnerCertificado}
                spinnerCertificado={spinnerCertificado}
                ProgressSpinner={ProgressSpinner}
                setspinnerNotas={setspinnerNotas}
                spinnerNotas={spinnerNotas}
                PersonaProgamaData={PersonaProgamaData}
              />
              {programa && <CardCursoVideoInicioComponent curso={programa} />}
            </div>
            <CardDownloadPrograma
              listaCursoPrograma={listaCursoPrograma}
              listaEvaluacionesUnidadeCursoPrograma={
                listaEvaluacionesUnidadeCursoPrograma
              }
              Persona={Persona}
              programa={programa}
              listaUnidadeCursoPrograma={listaUnidadeCursoPrograma}
              setspinnerCertificado={setspinnerCertificado}
              spinnerCertificado={spinnerCertificado}
              ProgressSpinner={ProgressSpinner}
              setspinnerNotas={setspinnerNotas}
              spinnerNotas={spinnerNotas}
              PersonaProgamaData={PersonaProgamaData}
            />
            <AvanceModulosComponent
              listaCursoPrograma={listaCursoPrograma}
              listaProgresoLeccionUnidadeCursoPrograma={
                listaProgresoLeccionUnidadeCursoPrograma
              }
              listaUnidadeCursoPrograma={listaUnidadeCursoPrograma}
              listaLeccionUnidadeCursoPrograma={listaLeccionUnidadeCursoPrograma}
              listaEvaluacionesUnidadeCursoPrograma={
                listaEvaluacionesUnidadeCursoPrograma
              }
              CursoEvaluacion={CursoEvaluacion}
            />
            <ModulosAcordionProgramaComponent
              idPrograma={idPrograma}
              listaCursoPrograma={listaCursoPrograma}
              listaProgresoLeccionUnidadeCursoPrograma={
                listaProgresoLeccionUnidadeCursoPrograma
              }
              listaUnidadeCursoPrograma={listaUnidadeCursoPrograma}
              listaEvaluacionesUnidadeCursoPrograma={
                listaEvaluacionesUnidadeCursoPrograma
              }
              listaLeccionUnidadeCursoPrograma={listaLeccionUnidadeCursoPrograma}
              Persona={Persona}
              curso={curso}
              setListaBiblioteca={setListaBiblioteca}
              setcursoActivarSeleccion={setcursoActivarSeleccion}
              cursoActivarSeleccion={cursoActivarSeleccion}
              LeccionesPendientesUnidadCurso={LeccionesPendientes}
            />
            <BibliotecaVirtualComponent
              listaBiblioteca={listaBiblioteca}
              cursoPersona={cursoPersona}
            />
            <PreguntasFrecuentesComponent />
          </div>
        )}
        
        <FooterInterno />

        <DialogZegel
          header=""
          visible={showAlert}
          width="30vw"
          onHide={() => setShowAlert(false)}
          footer={footerActivar}
          contenido={contenidoAlertActivar}
        ></DialogZegel>
      </div>
    </>
  );
};

export default ProgresoPrograma;